module.exports = __webpack_public_path__ + "img/Loading_46@2x.9756c687.png";